/**
 * Когда рассылку можно отправлять.
 *
 * Отдельной функцией, потому что цена ошибки тут наибольшая на всей админке:
 * объявление уходит живым людям и назад не возвращается.
 *
 * Правило, ради которого всё это писано: **показанное число получателей
 * должно быть посчитано для той же аудитории, которая уйдёт.** Раньше проверки
 * было две — «предпросмотр есть» и «в нём не ноль», — и обе врали при смене
 * аудитории: старое число висело на экране, пока считалось новое, а кнопка
 * оставалась живой. Один клик в это окно — и вместо троих отмеченных
 * объявление уходило всем шестистам.
 */
export interface BroadcastGate {
  message: string;
  /** Отпечаток аудитории, для которой посчитан предпросмотр. */
  previewKey: string | null;
  previewCount: number;
  /** Отпечаток аудитории, которая уйдёт при нажатии. */
  audienceKey: string;
  /** Предпросмотр сейчас пересчитывается. */
  previewing: boolean;
  sending: boolean;
}

export function canSendBroadcast(gate: BroadcastGate): boolean {
  return (
    gate.message.trim() !== '' &&
    !gate.previewing &&
    !gate.sending &&
    gate.previewKey === gate.audienceKey &&
    gate.previewCount > 0
  );
}
